export const SUPPORT_EMAIL = 'support@auteurintelligence.com';
